(() => {
	angular
		.module('main')
		.directive('sendQuestionnaireModal', sendQuestionnaireModal);

	sendQuestionnaireModal.$inject = [];

	function sendQuestionnaireModal() {
		return {
			scope: true,
			template: require('./sendQuestionnaire.component.html')
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/questionnaire/sendQuestionnaire.component.js